import { TApplicationState } from '../../types/redux';

export function getHouses({ newbuilding: { housesByName } }: TApplicationState) {
  if (!housesByName) {
    return [];
  }

  return housesByName.filter(house => !!house.fromDeveloperPropsCount);
}
